export default {
  palette: {
    primary: {
      light: "#00ccff",
      main: "#0099ff",
      dark: "#00759f",
      contrastText: "#fff",
    },
    secondary: {
      light: "#ff5999",
      main: "#e73c7e",
      dark: "#d40052",
      contrastText: "#fff",
    },
    tertiary: {
      light: "#FF7575",
      main: "#fff",
      dark: "#FF3F3F",
      contrastText: "#20cae6",
    },
  },
  spread: {
    typography: {
      useNextVariants: true,
    },
    formWrapper: {
      textAlign: "center",
      padding: "0 10px",
    },
    form: {
      padding: "0 15px",
    },
    image: {
      margin: "20px auto 10px auto",
      width: "40px",
      height: "40px",
    },
    pageTitle: {
      color: "rgb(0,0,0,0.7)",
      margin: "15px auto 0 auto",
      fontWeight: "bold",
      fontSize: 37,
    },
    subTitle: {
      color: "rgb(0,0,0,0.5)",
      fontWeight: "bold",
      margin: "0 auto 15px auto",
    },
    textField: {
      background: "none",
      fontWeight: 400,
      border: "2px solid #23a65",
      borderWidth: 2,
      borderStyle: "solid",
      borderImage: "linear-gradient(45deg, #e73c7e, #23a6d5) 20% stretch",
      padding: "0.5em 1em",
      marginBottom: "2.5em",
      width: "90%",
    },
    postTextField: {
      background: "none",
      fontWeight: 400,
      border: "none",
      padding: "0.5em 0",
      marginBottom: "0.5em",
    },
    labels: {
      fontWeight: 700,
      background: "#fff",
      padding: " 2px 5px 2px 5px",
      height: "auto",
      width: "auto",
      color: "#333",
      position: "absolute",
      marginTop: "-13px",
      marginLeft: "15px",
      zIndex: 2,
    },
    labelsDark: {
      fontWeight: 700,
      background: "#161829",
      padding: " 2px 5px 2px 5px",
      height: "auto",
      width: "auto",
      color: "#fff",
      position: "absolute",
      marginTop: "-13px",
      marginLeft: "15px",
      zIndex: 2,
    },
    helperText: {
      position: "absolute",
      marginTop: "4em",
    },
    link: {
      color: "#00b0ff",
      fontWeight: "bold",
    },
    button: {
      fontSize: 15,
      textShadow: "0 3px 5px rgba(0,0,0,0.5)",
      boxShadow: "0 5px 10px rgba(0,0,0,0.2)",
      background: "#161829",
      color: "#fff",
      border: "none",
      height: 45,
      borderRadius: "5px",
      fontWeight: "bold",
      width: " 60%",
      cursor: "pointer",
      letterSpacing: "2px",
      transition: "0.3s all ease-in-out",
      "&:hover": {
        width: "90%",
        background: "#2E3355",
        transition: "0.3 all ease-in-out",
      },
    },
    subtleButton: {
      padding: "6px 50px",
      borderRadius: 20,
      fontSize: 15,
      fontWeight: "bold",
    },
    glowButton: {
      fontSize: 15,
      textShadow: "0 3px 5px rgba(0,0,0,0.5)",
      boxShadow: "0 0 0.8em #00ccff",
      background: "#0099ff",
      color: "#fff",
      border: "none",
      height: 40,
      borderRadius: "5px",
      fontWeight: "bold",
      width: "8em",
      cursor: "pointer",
      letterSpacing: "2px",
      textTransform: "none",
      transition: "0.3s all ease-in-out",
      "&:hover": {
        background: "#00ccff",
        boxShadow: "0 0 1.3em #00ccff",
        transition: "0.3 all ease-in-out",
      },
    },
    cardWrapper: {
      position: "relative",
      display: "flex",
      flexDirection: "row",
      padding: "1em",
    },
    customError: {
      color: "red",
      fontSize: "0.8rem",
      margin: "-20px 0 20px 0",
    },
    progress: {
      position: "absolute",
    },
    brand: {
      fontSize: 60,
      fontWeight: 700,
      letterSpacing: "3px",
    },
    smallBrand: {
      color: "#fff",
      fontSize: 25,
      fontWeight: 700,
      letterSpacing: "3px",
      textShadow: "0 5px 5px rgba(0,0,0,0.3)",
    },
    invisibleSeparator: {
      border: "none",
      margin: 4,
    },
    visibleSeparator: {
      width: "80%",
      marginBottom: 20,
    },
    paper: {
      padding: 20,
      margin: "0 0 20px 0",
    },
    profile: {
      margin: "0 auto",
      maxWidth: 500,
      textAlign: "center",
      padding: "10px 40px 20px 40px",
      "& .image-wrapper": {
        position: "relative",
      },
      "& .profile-image": {
        width: 120,
        height: 120,
        objectFit: "cover",
        borderRadius: "50%",
      },
    },
    buttons: {
      textAlign: "center",
      "& a": {
        margin: "20px 10px",
      },
    },
    icon: {
      fontSize: 25,
      color: "#8f93b5",
      cursor: "pointer",
    },
    wrap: {
      position: "relative",
      display: "flex",
      alignItems: "center",
      width: "100%",
      padding: "0 0 1em 5.6em",
    },
    wrapIcon: {
      fontSize: 20,
      display: "flex",
      alignItems: "center",
      marginRight: "0.3em",
      cursor: "pointer",
      zIndex: 5,
      transition: "0.3s",
    },
    date: {
      fontSize: 12,
      margin: "0.25em 0",
      color: "#5a5d75",
    },
    rightSpace: {
      paddingRight: 20,
    },
    thickSeparator: {
      height: 3,
      width: "100%",
      border: "none",
      backgroundColor: "#222540",
      margin: 0,
    },
    rightAlign: {
      textAlign: "right",
    },
    // create post
    submitButton: {
      marginTop: 5,
      borderRadius: 20,
      fontSize: 13,
      fontWeight: "bold",
      textShadow: "0 5px 5px rgba(0,0,0,0.3)",
      boxShadow: "0 5px 5px rgba(0,0,0,0.2)",
      padding: "7px 20px",
    },
    progressSpinner: {
      position: "absolute",
    },
    closeButton: {
      position: "absolute",
      left: "91%",
      top: "6%",
      cursor: "pointer",
    },
    addButton: {
      cursor: "pointer",
      fontSize: "40pt",
    },
    bottomNav: {
      height: "10vh",
      width: "100%",
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "center",
      alignItems: "center",
      fontSize: 12,
      color: "#fff",
      padding: "5px 0px",
      "& span": {
        margin: "0 7px",
        textShadow: "0 5px 10px rgba(0,0,0,0.3)",
        cursor: "pointer",
        textAlign: "center",
      },
    },
    sectionTitle: {
      color: "rgb(0,0,0,0.7)",
      margin: "10px auto 05px auto",
      fontWeight: "bold",
      fontSize: 30,
      width: "100%",
    },
  },
};
